import classNames from 'classnames';
import React from 'react';

import LayoutComposer from '../LayoutComposer';
import css from './LayoutSingleColumn.module.css';

type P = {
  className?: string;
  rootClassName?: string;
  mainColumnClassName?: string;
  footerClassName?: string;
  topbar: React.ReactNode;
  footer?: React.ReactNode;
};

// Commonly used layout
const LayoutSingleColumn: React.FC<P> = props => {
  const {
    className,
    rootClassName,
    mainColumnClassName,
    footerClassName,
    children,
    topbar: topbarContent,
    footer: footerContent,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <LayoutComposer areas={layoutAreas} className={classes} {...rest}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={css.topbar}>
              {topbarContent}
            </Topbar>
            <Main as="main" className={classNames(css.main, mainColumnClassName)}>
              {children}
            </Main>
            <Footer className={classNames(css.footer, footerClassName)}>{footerContent}</Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

export default LayoutSingleColumn;
